import { listingPagesFiltreMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [listingPagesFiltreMock];

export const lpSemSommaireMock: SlugPage = {
  ...pageBase({
    title: 'LP sem - Sommaire',
    type: 'lp-sem',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
